module.exports = __webpack_public_path__ + "static/media/icon-react.79aaa8c8.svg";